import React, { useState } from "react";
import { Link } from "react-router-dom";

import slideImage1 from '../assets/images/hero-image-1.png';
import slideImage3 from '../assets/images/hero-image-3.png';

import lifestyleImage from "../assets/images/sub-lifestyle.jpg";
import RevealText from "../components/RevealText"; 


// --- SLIDER DATA ---
const slidesData = [
  {
    id: 1,
    image: slideImage1,
    title: "Explore Our Curated Store",
    subtitle: "From handcrafted ceramics to premium coffee beans, find your perfect match.",
    buttonText: "SHOP THE COLLECTION",
    link: "/store",
  },
  {
    id: 2,
    image: lifestyleImage,
    title: "Curated for Your Home",
    subtitle: "Experience the best of specialty coffee without leaving your house. Each delivery is a new discovery, selected by our experts.",
    buttonText: "VIEW OUR SUBSCRIPTION PLANS",
    link: "/subscription",
  },
  {
    id: 3,
    image: slideImage3,
    title: "Master the Craft of Coffee",
    subtitle: "Join our training sessions and workshops to elevate your brewing skills.",
    buttonText: "BROWSE TRAINING PROGRAMS",
    link: "/training",
  },
];

const HeroSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? slidesData.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const goToNext = () => {
    const isLastSlide = currentIndex === slidesData.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  const formatPageNumber = (num) => num.toString().padStart(2, "0");

  return (
    // The Block
    <div className="hero-slider">
      
      {/* Element: Background */}
     <div className="hero-slider__background">
        {slidesData.map((slide, index) => (
          <div
            key={slide.id}
            className={`hero-slider__image ${index === currentIndex ? "hero-slider__image--active" : ""}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            {/* --- THE FIX --- */}
            {/* This empty div will serve as our dark overlay */}
            <div className="hero-slider__overlay"></div>
          </div>
        ))}
      </div>

      {/* Element: Content */}
      <div className="hero-slider__content">
        <h1>{slidesData[currentIndex].title}</h1>
        <p>{slidesData[currentIndex].subtitle}</p>
        {/* Element: Call to Action */}
        <Link to={slidesData[currentIndex].link} className="hero-slider__cta">
          {slidesData[currentIndex].buttonText}
        </Link>
      </div>

      {/* Element: Navigation (with Modifier) */}
      <button onClick={goToPrevious} className="hero-slider__nav hero-slider__nav--prev">
        &larr;
      </button>
      <button onClick={goToNext} className="hero-slider__nav hero-slider__nav--next">
        &rarr;
      </button>

      {/* Element: Pagination */}
      <div className="hero-slider__pagination">
        {/* Pagination Elements */}
        <span className="hero-slider__pagination-current">
          {formatPageNumber(currentIndex + 1)}
        </span>
        <span className="hero-slider__pagination-divider"></span>
        <span className="hero-slider__pagination-total">
          {formatPageNumber(slidesData.length)}
        </span>
      </div>
    </div>
  );
};

export default HeroSlider;